const { spacing } = require("tailwindcss/defaultTheme")

module.exports = {
  ...spacing,
  26: "6.5rem",
}
